import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Gift } from '@app/models/gift';
import * as AuthActions from '@app/store/features/auth/auth.actions';
import * as RAFBonusesActions from '@app/store/features/raf-bonuses/raf-bonuses.actions';
import { RAFBonuse } from '@app/models/raf-bonuses';

export interface State extends EntityState<RAFBonuse> {

}

export const adapter: EntityAdapter<RAFBonuse> = createEntityAdapter<RAFBonuse>({
    selectId: (model: RAFBonuse) => model.idMember,
});

export const initialState: State = adapter.getInitialState({

});

export const reducer = createReducer(initialState,

    on(RAFBonusesActions.setAll, (state, { rafBonuses }) => {
        return adapter.setAll(rafBonuses, state);
    }),

    on(AuthActions.onLogout, (state) => {
        return adapter.removeAll({ ...state });
    }),
);
